import { type Observable } from 'rxjs';

import { type SetValueOptions } from './question-base';
import {
  QuestionMultiBase,
  type IMultiSelectItem,
  type IQuestionMultiBase,
} from './question-multi-base';

export interface IQuestionMultiSelect<T = any, V = any> extends Omit<
  IQuestionMultiBase<T, V, true>,
  'multi'
> {
  draggable?: boolean;
}

export class QuestionMultiSelect<T = any, V = any>
  extends QuestionMultiBase<T, V, true>
  implements IQuestionMultiBase<T, V, true>
{
  public draggable: boolean = false;

  constructor(options: IQuestionMultiSelect<T, V>) {
    super({
      ...options,
      multi: true,
    });

    this.elementType = 'multi';
    this.draggable = options.draggable;
  }

  public override equals(values: T[]): boolean {
    return super.equals(values, true);
  }

  public override getValue(): T[] {
    return super.getValue();
  }

  public override get options(): Observable<IMultiSelectItem<T, V>[]> {
    return super.options as Observable<IMultiSelectItem<T, V>[]>;
  }

  public dragged(items: IMultiSelectItem<T>[]): void {
    items.forEach((item, index) => {
      item.position = index;
    });
    this.setOptions(items);
  }

  public override setValue(
    value: T[],
    opts: SetValueOptions = { emitEvent: true, force: false },
  ): void {
    super.setValue(value, opts);
  }
}
